import { create } from 'zustand';
import type { HabitFormValues } from '@/features/habits/habitSchema';

export type HabitDetailMode = 'view' | 'edit' | 'add';

export interface HabitDetailState {
  selectedHabitId: string | null;
  mode: HabitDetailMode;
  prefill: Partial<HabitFormValues> | null;
  open: (habitId: string, mode?: HabitDetailMode) => void;
  openAdd: (prefill?: Partial<HabitFormValues>) => void;
  setMode: (mode: HabitDetailMode) => void;
  close: () => void;
}

export const useHabitDetail = create<HabitDetailState>((set) => ({
  selectedHabitId: null,
  mode: 'view',
  prefill: null,
  open: (habitId, mode = 'view') => set({ selectedHabitId: habitId, mode, prefill: null }),
  openAdd: (prefill) => set({ selectedHabitId: null, mode: 'add', prefill: prefill ?? null }),
  setMode: (mode) => set({ mode }),
  close: () => set({ selectedHabitId: null, mode: 'view', prefill: null }),
}));
